export default __webpack_public_path__ + "static/media/chevron-down-2.870ddf28.svg";